import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { adminAPI } from "@/services/api";
import { ShieldCheck, Loader2 } from "lucide-react";
import api from "@/services/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let res;
      if (mode === "login") {
        res = await adminAPI.login(email, password);
      } else {
        res = await adminAPI.register(name, email, password);
      }
      const token = res.data.access_token;
      localStorage.setItem("admin_token", token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      toast.success(mode === "login" ? "Welcome back!" : "Admin created!");
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4 font-sans">
      <section className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-500 text-white shadow-theme-xs">
            <ShieldCheck className="h-7 w-7" />
          </div>
          <h1 className="text-xl font-semibold text-gray-900">Proovam Admin</h1>
          <p className="mt-1 text-sm text-gray-500">
            {mode === "login" ? "Sign in to admin panel" : "Create admin account"}
          </p>
        </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            {mode === "register" && (
              <div className="space-y-1.5">
                <Label className="text-sm text-gray-700">Name</Label>
                <Input
                  placeholder="Admin Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            )}
            <div className="space-y-1.5">
              <Label className="text-sm text-gray-700">Email</Label>
              <Input
                type="email"
                placeholder="admin@proovam.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="space-y-1.5">
              <Label className="text-sm text-gray-700">Password</Label>
              <Input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
              {mode === "login" ? "Sign In" : "Create Account"}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <button
              onClick={() => setMode(mode === "login" ? "register" : "login")}
              className="text-sm font-medium text-brand-500 hover:text-brand-600"
            >
              {mode === "login" ? "Need an admin account? Register" : "Already have an account? Sign In"}
            </button>
          </div>
      </section>
    </div>
  );
};

export default AdminLogin;
